// src/lang/index.js - 修复循环依赖的多语言配置
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 引入各个语言配置文件
import cn from '@/lang/cn'
import en from '@/lang/en'
import es from '@/lang/es'
import fr from '@/lang/fr'
import by from '@/lang/by'
import de from '@/lang/de'
import it from '@/lang/it'

Vue.use(VueI18n)

// 在此文件中定义语言常量，避免循环依赖
const supportedLanguages = ['en', 'cn', 'es', 'by', 'fr','de','it']
const defaultLanguage = 'en'

// 语言映射表
const messages = {
  cn,
  en,
  es,
  fr,
  by,
  de,
  it
}

// 获取初始语言设置
const getInitialLocale = () => {
  // 优先级：localStorage > 浏览器语言 > 默认语言
  const stored = localStorage.getItem('language')
  if (stored) {
    try {
      const parsed = JSON.parse(stored)
      if (supportedLanguages.includes(parsed.country)) {
        return parsed.country
      }
    } catch (error) {
      console.warn('Failed to parse stored language:', error)
    }
  }
  
  // 检查浏览器语言
  const browserLang = navigator.language.split('-')[0]
  if (supportedLanguages.includes(browserLang)) {
    return browserLang
  }
  
  return defaultLanguage
}

// 创建 vue-i18n 实例
const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: defaultLanguage,
  messages,
  // 静默警告（可选）
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  silentFallbackWarn: process.env.NODE_ENV === 'production'
})

// 语言切换辅助函数
export const setI18nLanguage = (lang) => {
  if (supportedLanguages.includes(lang)) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
  }
  return i18n.locale
}

// 获取当前 i18n 语言
export const getCurrentI18nLanguage = () => i18n.locale

// 暴露配置和工具
export { supportedLanguages, defaultLanguage, messages, i18n }
export default i18n
